// Души коротко: «8,6 тыс.», «800» — для подписей у полос и в текстах о закупе.
export const formatSouls = (souls: number, locale: string): string =>
  new Intl.NumberFormat(locale, { notation: "compact", maximumFractionDigits: 1 }).format(souls);
